<lib-scroller [forceChange]="tags()">
  <lib-breadcrumbs
    data-test="tags"
    [buttons]="tags()"
    (clicked)="handleTagClick($event)"
  />
</lib-scroller>
